import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const BetslipButton = props => {
    const {
        isQa,
        isDeleteButton,
        isDoneButton,
        isDotSign,
        value,
        isBabyBetslip,
        isIncrementButton,
    } = props;

    const [t] = useTranslation();

    return (
        <div
            className={[
                isBabyBetslip ? 'js-keyboard-button baby-betslip-keyboard__button' : 'betslip-fancy-keyboard__button js-keyboard-button',
                isQa && (isBabyBetslip ? 'baby-betslip-keyboard__button--quickamount' : 'betslip-fancy-keyboard__button--quickamount'),
                isDeleteButton && (isBabyBetslip ? 'baby-betslip-keyboard__button--delete' : 'betslip-fancy-keyboard__button--delete'),
                isDoneButton && (isBabyBetslip ? 'baby-betslip-keyboard__button--done' : 'betslip-fancy-keyboard__button--done'),
            ].filter(Boolean).join(' ')}

            data-btnvalue={[
                isQa && `qa-${value}`,
                isDeleteButton && 'action-back',
                isDoneButton && 'action-done',
                isDotSign && 'sign-dot',
                !isQa && !isDeleteButton && !isDoneButton && !isDotSign && value,
            ].filter(Boolean).join(' ')}

            data-increment={ isIncrementButton ? value : '' }
        >
            <div className={[
                'ripple',
                'betslip-keyboard__button',
                isIncrementButton && 'betslip-keyboard__button--increment',
                isDoneButton && 'betslip-keyboard__button--done',
                isDeleteButton && 'betslip-keyboard__button--delete',
            ].filter(Boolean).join(' ')}
            >
                {isIncrementButton ? '+' : ''}
                {!isNaN(value) ? value : t(value)}
            </div>
        </div>
    );
};

BetslipButton.propTypes = {
    value: PropTypes.string,
    isQa: PropTypes.bool,
    isDeleteButton: PropTypes.bool,
    isDoneButton: PropTypes.bool,
    isDotSign: PropTypes.bool,
    isBabyBetslip: PropTypes.bool,
    isIncrementButton: PropTypes.bool,
};

BetslipButton.defaultProps = {
    value: '',
    isQa: false,
    isDeleteButton: false,
    isDoneButton: false,
    isDotSign: false,
    isBabyBetslip: false,
    isIncrementButton: false,
};

export default BetslipButton;
